export default __webpack_public_path__ + "static/media/genom@3x.a0ec8782.png";